<template>
  <div class="h-24 flex items-center">
    <p class="text-center w-full text-80">{{ $t('No data matched your search criteria.') }}</p>
  </div>
</template>

<script>
  export default {};
</script>
